import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initGA } from './utils/initGA';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Defer GA until after first paint so it doesn't delay FCP
const scheduleGA = () => {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(() => { try { initGA(); } catch (e) { console.error(e); } }, { timeout: 2000 });
  } else {
    setTimeout(() => { try { initGA(); } catch (e) { console.error(e); } }, 0);
  }
};
scheduleGA();